import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { useSharedNotes } from 'features/shared-notes/useSharedNotes';

export const useSharedNotesControl = () => {
  const { isPanelVisible, togglePanel } = useSidePanel();

  const { isFeatureAvailable } = useSharedNotes();

  const toggleSharedNotesPanel = () => {
    togglePanel('shared-notes');
  };

  return {
    active: isPanelVisible('shared-notes'),
    togglePanel: toggleSharedNotesPanel,
    icon: 'shared-notes',
    isFeatureAvailable,
  };
};
